"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreightUnit = exports.FreightOption = exports.FreightShipmentMode = void 0;
var FreightShipmentMode;
(function (FreightShipmentMode) {
    FreightShipmentMode["LTL"] = "LTL";
    FreightShipmentMode["FTL"] = "FTL";
    FreightShipmentMode["DRAYAGE"] = "DRAYAGE";
    FreightShipmentMode["INTERMODAL"] = "INTERMODAL";
    FreightShipmentMode["TRANSLOAD"] = "TRANSLOAD";
    FreightShipmentMode["VLTL"] = "VLTL";
    FreightShipmentMode["FCL"] = "FCL";
})(FreightShipmentMode = exports.FreightShipmentMode || (exports.FreightShipmentMode = {}));
var FreightOption;
(function (FreightOption) {
    FreightOption["DROP_TRAILER"] = "DROP_TRAILER";
    FreightOption["FLOOR_LOADED_UNLOAD"] = "FLOOR_LOADED_UNLOAD";
    FreightOption["LIVE_UNLOAD"] = "LIVE_UNLOAD";
})(FreightOption = exports.FreightOption || (exports.FreightOption = {}));
var FreightUnit;
(function (FreightUnit) {
    FreightUnit["CONTAINER"] = "CONTAINER";
    FreightUnit["PALLET"] = "PALLET";
    FreightUnit["TRAILER"] = "TRAILER";
})(FreightUnit = exports.FreightUnit || (exports.FreightUnit = {}));
//# sourceMappingURL=FreightPricingStrategy.js.map